(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('EpmParamsDialogController', EpmParamsDialogController);

    EpmParamsDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'EpmParams'];

    function EpmParamsDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, EpmParams) {
        var vm = this;

        vm.epmParams = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.epmParams.id !== null) {
                EpmParams.update(vm.epmParams, onSaveSuccess, onSaveError);
            } else {
                EpmParams.save(vm.epmParams, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('moldovaYieldCurvesApp:epmParamsUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
